<app-navbar></app-navbar>
<div *ngIf="loading">
  <div class="row">
    <div class="col-12 col-md-4 mx-auto text-center">
      <img src="assets/loader.svg" class="d-block ml-auto mr-auto" alt="spinner">
    </div>
  </div>
</div>
<div class="fixtures-page" *ngIf="!loading">
  <div class="row mt-4 mb-3">
    <div class="col-12 col-md-4 mx-auto fixtures-panel">
      <header class="fixtures-header">
        <p class="fixtures-eyebrow">Race meetings</p>
      </header>
      <form class="form fixtures-date-form">
        <div class="form-group mb-0">
          <label class="font-weight-bold" for="fixtureDate">Select date of fixture</label>
          <div class="input-group">
            <input class="form-control" placeholder="dd-mm-yyyy" id="fixtureDate" name="fixtureDate" [(ngModel)]="fixtureDate" (ngModelChange)="getFixtures($event)" ngbDatepicker #fixturesDate="ngbDatepicker" (click)="fixturesDate.toggle(); $event.stopPropagation();" (document:click)="datepickerFix($event, fixturesDate)" readonly>
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="fixturesDate.toggle(); $event.stopPropagation();" type="button">
                <fa name="calendar"></fa>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row pt-2">
    <div class="col-12 col-md-4 mx-auto fixtures-panel">
      <div class="fixtures-list" *ngIf="fixturesList && fixturesList.length; else noFixtures">
        <ng-container *ngFor="let fixture of fixturesList">
          <a
            *ngIf="canOpenFixture(fixture)"
            class="fixture-card"
            [routerLink]="fixture.racesLink"
            [ngClass]="fixtureCardClasses(fixture)">
            <ng-container *ngTemplateOutlet="fixtureCardContent; context: { $implicit: fixture, linkable: true }"></ng-container>
          </a>
          <div
            *ngIf="!canOpenFixture(fixture)"
            class="fixture-card fixture-card-static"
            [ngClass]="fixtureCardClasses(fixture)">
            <ng-container *ngTemplateOutlet="fixtureCardContent; context: { $implicit: fixture, linkable: false }"></ng-container>
          </div>
        </ng-container>
      </div>

      <ng-template #fixtureCardContent let-fixture let-linkable="linkable">
        <span
          *ngIf="privilegeBadge(fixture) as badge"
          class="fixture-badge-rp"
          [title]="badge">{{ badge }}</span>
        <div class="fixture-card-main">
          <div class="fixture-card-heading">
            <h3 class="fixture-course">
              {{ fixture.courseName }}
              <small *ngIf="fixture.fixtureType" class="fixture-type">
                ({{ fixture.fixtureType }}<span *ngIf="fixture.fixtureType !== 'JUMP' && fixture.racingTrackType"> - {{ fixture.racingTrackType }}</span>)
              </small>
            </h3>
            <div class="fixture-badges">
              <span
                *ngIf="fixture.isPremier"
                class="fixture-badge fixture-badge-premier"
                title="Premier fixture">
                Premier
              </span>
              <span
                *ngIf="fixture.trotUpsRequired"
                class="fixture-badge fixture-badge-trotup"
                title="All horse trot-up required">
                All Horse Trot Up
              </span>
              <span
                *ngIf="fixture.musicDescription"
                class="fixture-badge fixture-badge-music"
                [title]="fixture.musicDescription">
                {{ fixture.musicDescription }}
              </span>
            </div>
          </div>
          <div class="fixture-card-details" *ngIf="abandonedLabel(fixture) as abandonedText">
            <div class="fixture-detail-row">
              <div class="fixture-card-meta">
                <span class="fixture-meta-item fixture-abandoned-reason">
                  {{ abandonedText }}
                </span>
              </div>
            </div>
          </div>
          <div class="fixture-card-details" *ngIf="!fixture.abandonedReasonCode">
            <div class="fixture-detail-row">
              <span class="fixture-detail-icon" *ngIf="sessionLabel(fixture)">
                <fa *ngIf="fixture.floodlit" name="lightbulb-o"></fa>
                <fa *ngIf="!fixture.floodlit && fixture.fixtureSession === 'AFTERNOON'" name="sun-o"></fa>
                <fa *ngIf="!fixture.floodlit && fixture.fixtureSession === 'EVENING'" name="moon-o"></fa>
              </span>
              <div class="fixture-card-meta">
                <span class="fixture-meta-item fixture-session" *ngIf="sessionLabel(fixture)">
                  {{ sessionLabel(fixture) }}
                </span>
                <span class="fixture-meta-item" *ngIf="fixture.firstRaceTime || fixture.lastRaceTime">
                  <fa name="clock-o"></fa>
                  <ng-container *ngIf="fixture.firstRaceTime && fixture.lastRaceTime">
                    First/Last race {{ fixture.firstRaceTime | racetime }}–{{ fixture.lastRaceTime | racetime }}
                  </ng-container>
                  <ng-container *ngIf="fixture.firstRaceTime && !fixture.lastRaceTime">
                    First race {{ fixture.firstRaceTime | racetime }}
                  </ng-container>
                  <ng-container *ngIf="!fixture.firstRaceTime && fixture.lastRaceTime">
                    Last race {{ fixture.lastRaceTime | racetime }}
                  </ng-container>
                </span>
                <span class="fixture-meta-item" *ngIf="fixture.numberOfRaces != null || fixture.numberOfRunners != null">
                  <fa name="check-square-o"></fa>
                  {{ fixture.numberOfRaces || 0 }} races with {{ fixture.numberOfRunners || 0 }} runners
                </span>
              </div>
            </div>
            <div class="fixture-detail-row fixture-low-sun" *ngIf="showSunsetRow(fixture)">
              <span class="fixture-detail-icon">
                <svg class="sunset-icon" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
                  <path d="M4 18h16v1.5H4zm8-12a5 5 0 0 1 5 5h1.75A6.75 6.75 0 0 0 12 4.25 6.75 6.75 0 0 0 5.25 11H7a5 5 0 0 1 5-5zm-8.5 9h17v1.5h-17zm2.25-2.5h12.5v1.5H5.75zM11.25 5.5h1.5V3h-1.5zm6.01 2.23.95-.95 1.06 1.06-.95.95zm-11.52 0-.95-.95L6.35 5.78l.95.95z"/>
                </svg>
              </span>
              <span class="fixture-low-sun-time" *ngIf="fixture.sunsetTime">
                Sunset {{ fixture.sunsetTime }}
              </span>
              <span class="fixture-low-sun-message" *ngIf="fixture.lowSunProvision">
                {{ fixture.lowSunProvision }}
              </span>
            </div>
          </div>
        </div>
        <div class="fixture-card-chevron" *ngIf="linkable" aria-hidden="true">
          <fa name="chevron-right"></fa>
        </div>
      </ng-template>
      <ng-template #noFixtures>
        <div class="fixtures-empty">
          No fixtures found for this date.
        </div>
      </ng-template>
    </div>
  </div>
</div>
